import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { TooltipText } from 'presentation/components/TooltipText';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { CountLike } from '../../../CU-002-01/components/CountLike';
import { RateBadge } from '../../../CU-002-01/components/Rate';
import { TodoEntity } from '../../../CU-002-02/models/CardModel';
import { useAppSelector } from 'presentation/redux/hooks';
interface props {
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
    countLike?: number;
    isBookmarked: boolean;
    onClickBookmark: () => void;
    currentTodo: TodoEntity;
    bidPrice: number;
    purchaseAmount: number;
}
const tier_1 = ['0002000020'];
const tier_2 = [
    '0002000030',
    '0002000040',
    '0002000050',
    '0002000060',
    '0002000070',
    '0002000080',
    '0002000090',
    '0002000100',
    '0002000110',
    '0002000120',
];
export const MarketPriceBuyer = ({
    detailAssessment,
    countLike,
    isBookmarked,
    onClickBookmark,
    currentTodo,
    bidPrice,
    purchaseAmount,
}: props) => {
    const navigate = useNavigate();
    const userSlice = useAppSelector((state) => state.user);
    return (
        <section>
            <div
                className="center-inside row"
                style={{ height: 24, width: 'fit-content', marginTop: 16 }}
            >
                <section className="like-lable cell">
                    <TooltipText content={detailAssessment?.name ?? COMMON.EMPTY} maxLine={2} />
                </section>
                <section className="cell"></section>
                <section
                    className="cell"
                    style={{ textAlign: 'right', marginRight: 8, cursor: 'pointer' }}
                    onClick={onClickBookmark}
                >
                    <CountLike value={countLike} currentBookmarked={isBookmarked} />
                </section>
            </div>
            <div
                className="center-inside row"
                style={{ height: 24, width: 'fit-content', marginTop: 16 }}
            >
                <section className="cell">
                    <div className="flex">
                        {tier_2.includes(currentTodo.todoCode) && (
                            <div className="text-[#1F8DDD] bg-[#EBF7FF] rounded-[10px] py-[4px] px-[8px] font-[700] w-[76px] h-[20px] leading-[10px]">
                                購入申込中
                            </div>
                        )}
                        {tier_2.includes(currentTodo.todoCode) && currentTodo.todoExecStatus !== 'DONE' && (
                            <div className="text-[#ffffff] bg-[#86822E] rounded-[2px] py-[4px] px-[8px] font-[700] w-[88px] h-[20px] leading-[12px] ml-[8px]">
                                交渉権付与中
                            </div>
                        )}
                        {tier_2.includes(currentTodo.todoCode) && currentTodo.todoExecStatus === 'DONE' && (
                        <div className="text-[#ffffff] bg-[#86822E] rounded-[2px] py-[4px] px-[8px] font-[700] w-[88px] h-[20px] leading-[12px] ml-[8px]">
                            交渉権の消滅
                        </div>
                        )}
                        {![...tier_1, ...tier_2].includes(currentTodo.todoCode) && (
                            <div className="text-[#01AA6D] bg-[#DEF6E8] rounded-[10px] py-[4px] px-[8px] font-[700] w-[88px] h-[20px] leading-[12px] ml-[8px]">
                                購入確定
                            </div>
                        )}
                    </div>
                </section>
                <section className="cell"></section>
                <section className="cell"></section>
            </div>
            {tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">即決価格</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(detailAssessment?.askingSalePriceUpperLimit)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                    <RateBadge value={detailAssessment?.rateBuyNow} fill="#ffffff" />
                </div>
            )}

            {tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">現在の最高入札額</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(
                                    detailAssessment?.currentHighestAuctionPrice,
                                )
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                    <RateBadge
                        value={
                            detailAssessment?.currentHighestAuctionPrice
                                ? detailAssessment?.rateHighestAuctionNow
                                : 0
                        }
                        fill="#ffffff"
                    />
                </div>
            )}
            {tier_1.includes(currentTodo.todoCode) && detailAssessment?.yourAuctionBid && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">あなたの入札額</section>
                    <section
                        className="cell"
                        style={{ textAlign: 'right', marginRight: 8, display: 'table-cell' }}
                    >
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(detailAssessment?.yourAuctionBid)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                    <RateBadge value={detailAssessment?.rateYourAuctionBids} fill="#ffffff" />
                </div>
            )}
            {!tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">購入額</section>
                    <section
                        className="cell"
                        style={{ textAlign: 'right', marginRight: 8, display: 'table-cell' }}
                    >
                        <span className="mkp-number">
                            {commonHelpers.roundTenThousandYen(detailAssessment?.currentHighestAuctionPrice).toLocaleString('en-US', {
                                maximumFractionDigits: 2,
                            })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                    <RateBadge value={purchaseAmount} fill="#ffffff" />
                </div>
            )}

{(!userSlice.isSignedIn && (
                <section>
                    <p>※ 最低落札価格が設定されています。</p>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '50%' }}>
                            <p style={{ textAlign: 'center' }}>
                                シミュレーションは登録不要でご利用いただけます。
                            </p>
                            <div
                                className="form-button simulate-form-button"
                                onClick={() =>
                                    !userSlice.isSignedIn
                                        ? navigate(
                                              `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_01}`,
                                          )
                                        : null
                                }
                            >
                                シミュレーションへ
                            </div>
                        </div>
                        <div style={{ width: '50%' }}>
                            <p style={{ textAlign: 'center' }}>
                                もっと知りたい方はログインが必要です。
                            </p>
                            <div
                                className="form-button login-form-button"
                                onClick={() =>
                                    navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`)
                                }>
                                ログイン・アカウント作成へ
                            </div>
                        </div>
                    </div>
                </section>
            )) || <section style={{ border: '1px solid', marginTop: 20 }}></section>}
        </section>
    );
};